export enum CompanyInformationFieldName {
  Name = 'Company Name/DBA',
  PrimaryHomeImprovementCategory = 'Primary Home Improvement Category',
  OtherHomeImprovementCategory = 'Other Home Improvement Category',
  ContractorId = 'HFS Contractor ID',
  Email = 'Company Email',
  SecondEmail = '2nd Email',
  TertiaryEmail = '3rd Email',
  QuaternaryEmail = '4th Email',
  Phone = 'Company Phone',
  PersonalizedLink = 'Personalized Link',
}

export enum PrimaryHomeImprovementCategory {
  Additions = 'Additions',
  AduAttached = 'ADU - Attached',
  AduDetached = 'ADU - Detached',
  Basements = 'Basements',
  Bathrooms = 'Bathrooms',
  DeckingOrPatio = 'Decking / Patio',
  Electrical = 'Electrical',
  Fences = 'Fences',
  Flooring = 'Flooring',
  Hardscape = 'Hardscape',
  HomeAutomation = 'Home Automation',
  HomeEntertainment = 'Home Entertainment (mancave theater etc.)',
  HotTubs = 'Hot Tubs',
  Hvac = 'HVAC',
  Kitchens = 'Kitchens',
  Landscape = 'Landscape',
  MetalBuildings = 'Metal Buildings',
  Other = 'Other',
  OutdoorKitchens = 'Outdoor Kitchens',
  Pergolas = 'Pergolas',
  RoleBarns = 'Pole Barns',
  RoofAsphalt = 'Roof - Asphalt',
  RoofMetal = 'Roof - Metal',
  RoofShingles = 'Roof - Shingles',
  RoofTile = 'Roof - Tile',
  Saunas = 'Saunas',
  Security = 'Security',
  Solar = 'Solar',
  Siding = 'Siding',
  Spas = 'Spas',
  Sunrooms = 'Sunrooms / Three Seasons Rooms / Four Seasons Rooms',
  SwimmingPoolsInground = 'Swimming Pools - Inground',
  SwimmingPoolsAboveGround = 'Swimming Pools - Above Ground',
  SwimmingPoolsSemInground = 'Swimming Pools - Semi-Inground',
  SwimmingPoolsRemodel = 'Swimming Pools - Remodel / Renovation',
  WaterTreatment = 'Water Treatment',
  Windows = 'Windows',
}

export enum AddressInformationFieldName {
  CorporateAddress = 'Corporate Address',
  CorporateCity = 'Corporate City',
  CorporateState = 'Corporate State',
  CorporateZip = 'Corporate Zip Code',
  MailingAddress = 'Mailing Address',
  MailingCity = 'Mailing City',
  MailingState = 'Mailing State',
  MailingZip = 'Mailing Zip',
}

export enum SalespersonsInformationFieldName {
  Name = 'Name',
  Email = 'Email',
  MobilePhone = 'Mobile Phone',
}

export enum MainContactPosition {
  Owner = 'Owner',
  SalesManager = 'Sales Manager',
  Salesperson = 'Salesperson',
  FinanceManager = 'Finance Manager',
  Employee = 'Employee',
  AdminPerson = 'Admin Person',
}
